import * as xo from '@attraqt/xo-js';
import { getItem, removeItem, setItem } from '../../helpers/webStorage';

const LOCAL_STORAGE_KEY_ATTRAQT_TRACKER_ACTIVITIES = 'queuedAttraqtTrackerActivities';
let isInitialized = false;

function isAttraqtTrackerActive(): boolean {
  if (isInitialized) return true;

  const { trackerKey, isAttraqtTrackerEnabled } = window.bbGlobal.attraqt;
  if (trackerKey && isAttraqtTrackerEnabled) {
    xo.init({
      activity: {
        trackerKey
      }
    });
    xo.activity.getUserClusters().then((clusters) => {
      if (!clusters) {
        return;
      }
      const latestClusterID = getLatestClusterID(clusters);
      if (latestClusterID !== null) {
        setCookie('x-attraqt-clusterid', latestClusterID, 1);
      }
    });

    isInitialized = true;
    return true;
  }

  return false;
}

export enum Activities {
  CLICK = 'click',
  VIEW = 'view',
  ADD_TO_CART = 'add-to-cart',
  REMOVE_FROM_CART = 'remove-from-cart',
  PURCHASE = 'purchase'
}

function getLatestClusterID(clusters) {
  const algorithmID = Object.keys(clusters)[0];
  if (!algorithmID) {
    return null;
  }
  const timestamps = Object.keys(clusters[algorithmID]);
  const latestTimestamp = Math.max(...timestamps.map((ts) => Number(ts)));

  return clusters[algorithmID][latestTimestamp];
}

function setCookie(name, value, exdays) {
  const date = new Date();
  date.setTime(date.getTime() + exdays * 24 * 60 * 60 * 1000);
  document.cookie = `${name}=${value}; expires=${date.toUTCString()}; path=/`;
}

export type ActivityType = typeof xo.activity.sample & { action: Activities };

export function attraqtTracker(xactivity: ActivityType, shouldEnqueue = false): void {
  if (isAttraqtTrackerActive()) {
    xactivity.timestamp = new Date().toISOString();
    const activitiesQueue = getItem(LOCAL_STORAGE_KEY_ATTRAQT_TRACKER_ACTIVITIES, 'localStorage') || [];
    activitiesQueue.push(xactivity);

    if (shouldEnqueue) {
      setItem(LOCAL_STORAGE_KEY_ATTRAQT_TRACKER_ACTIVITIES, activitiesQueue, 'localStorage');
      return;
    }

    try {
      activitiesQueue.forEach((a: ActivityType) => xo.activity.send(a));
    } catch (e) {
      const { message } = e as Error;
      console.error('Please check attraqtTracker', message);
    } finally {
      // NOTE: In case attraqt returns broken data, we need to clean the local storage.
      // Otherwise, the event with the broken data will stay in local storage
      // and will be preventing the app to load properly.
      removeItem(LOCAL_STORAGE_KEY_ATTRAQT_TRACKER_ACTIVITIES, 'localStorage');
    }
  }
}
